import React, { useState } from 'react';
import { Box, Container, VStack, useBreakpointValue } from '@chakra-ui/react';
import { TopBar } from '@spotoninc/nexus-react';
import '../../styles/registration-styles.css';
import { ProgressStepper } from '../ProgressStepper/ProgressStepper';
import { AccountingSetup } from './AccountingSetup';
import { ContactDetails } from './ContactDetails';
import { Flex } from '@chakra-ui/react';
import { LoyaltyBrandIcon } from '@spotoninc/nexus-web-assets';
import { HeadingText } from '@spotoninc/nexus-react';

const RegistrationPage = ({ companyData }) => {
  const [step, setStep] = useState(1);
  // accountingSystem state is used by child components
  const [accountingSystem, setAccountingSystem] = useState('');

  // Responsive values
  const containerWidth = useBreakpointValue({
    base: '100%',
    md: '736px',
    lg: '70%',
  });
  const containerMargin = useBreakpointValue({
    base: '0',
    md: '5%',
    lg: '15%',
  });
  const paddingX = useBreakpointValue({ base: '4', md: '6' });

  const steps = [
    { id: 1, name: 'Accounting' },
    { id: 2, name: 'Contact Details' },
  ];
  // Accounting systems are defined in the AccountingSetup component

  const customAppName = (
    <Flex
      align="center"
      gap="8px"
      pl="0"
      style={{
        marginLeft: 0,
        paddingLeft: 0,
      }}
      className="app-name-container"
    >
      <LoyaltyBrandIcon
        size="2rem"
        color="#FFFFFF"
        className="app-logo"
        style={{ marginRight: '18px' }}
      />
      <HeadingText className="app-name">Profit Assist</HeadingText>
    </Flex>
  );
  return (
    <Box minH="100vh" bg="white">
      {/* Top Bar */}
      <TopBar
        applicationName={customAppName}
        currentPageName="Profit Assist"
        className="registration-topbar"
      />

      {/* Main Content */}
      <Container
        maxW={containerWidth}
        py={8}
        mx={containerMargin}
        px={paddingX}
        className="registration-content"
      >
        <VStack spacing={10} align="stretch">
          <ProgressStepper steps={steps} currentStep={step} />

          {/* Form Section */}
          {step === 1 && (
            <AccountingSetup
              companyData={companyData}
              onNext={system => {
                setAccountingSystem(system);
                setStep(2);
              }}
              onCancel={() => setStep(2)}
            />
          )}
          {step === 2 && (
            <ContactDetails
              companyData={companyData}
              setStep={setStep}
              setAccountingSystem={setAccountingSystem}
            />
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default RegistrationPage;
